export default {
  common: {
    unexpected: '予期せぬエラーが発生しました',
    tryAgain: '後でもう一度お試しください',
    refresh: 'ページを更新'
  },
  network: {
    offline: 'オフラインのようです',
    connectionLost: '接続が切断されました',
    serverError: 'サーバーエラー',
    requestFailed: 'リクエストに失敗しました'
  },
  game: {
    loadFailed: 'ゲームの読み込みに失敗しました',
    unsupported: 'お使いのブラウザはこのゲームをサポートしていない可能性があります',
    missingDependencies: 'ゲームを実行するために必要なコンポーネントが不足しています'
  },
  validation: {
    required: 'この項目は必須です',
    email: '有効なメールアドレスを入力してください',
    minLength: '少なくとも{min}文字を入力してください',
    maxLength: '{max}文字を超えることはできません'
  }
}; 